import { Link } from "react-router-dom";
import { LogoMark } from "@/components/app/Brand";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Acceptance of terms",
    body: "By creating an account or otherwise using CombinedWork (\"the Service\"), you agree to be bound by these Terms of Use. If you're using the Service on behalf of an organisation, you're agreeing on that organisation's behalf and confirming you have authority to do so.",
  },
  {
    title: "2. Your account",
    body: "You're responsible for maintaining the security of your account and password. CombinedWork cannot and will not be liable for any loss or damage from your failure to comply with this security obligation. You must notify us immediately of any unauthorised use of your account.",
  },
  {
    title: "3. Subscription plans and billing",
    body: "Paid plans are billed in advance on a monthly or annual basis. Free trials, where offered, convert to a paid subscription at the end of the trial period unless cancelled beforehand. You can upgrade, downgrade, or cancel your subscription at any time from your account billing settings.",
  },
  {
    title: "4. Your data",
    body: "You retain all rights to the content and data you upload to the Service. We only access your data to provide and support the Service, or as required by law. You can export your data at any time, and it is deleted from active systems within a reasonable period after account closure.",
  },
  {
    title: "5. Acceptable use",
    body: "You agree not to use the Service to violate any law, infringe on the rights of others, transmit malicious code, or attempt to gain unauthorised access to any part of the Service or its underlying infrastructure.",
  },
  {
    title: "6. Service availability",
    body: "We aim to keep the Service available at all times but do not guarantee uninterrupted access. We may perform scheduled maintenance and will make reasonable efforts to notify you in advance of anything that materially affects availability.",
  },
  {
    title: "7. Termination",
    body: "You may cancel your account at any time. We may suspend or terminate accounts that violate these terms, with notice where practical. Upon termination, your right to use the Service ends immediately, though data export remains available for a limited period as described above.",
  },
  {
    title: "8. Changes to these terms",
    body: "We may update these terms from time to time. We'll notify active customers of material changes by email or in-app notice before they take effect.",
  },
  {
    title: "9. Contact",
    body: "Questions about these terms? Email us at hello@combinedwork.com.",
  },
];

export default function Terms() {
  return (
    <div className="bg-white text-gray-900 min-h-screen font-sans">
      <nav className="border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl bg-violet-600 grid place-items-center shadow-md shadow-violet-200">
              <LogoMark size={16} color="#fff" />
            </div>
            <span className="text-base font-bold text-gray-900 tracking-tight">Combined<span className="text-violet-600">Work</span></span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to home
          </Link>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tight text-gray-900 mb-2">Terms of Use</h1>
        <p className="text-gray-400 text-sm mb-12">Last updated 9 July 2026</p>

        <div className="space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-semibold text-gray-900 text-base mb-2">{s.title}</h2>
              <p className="text-gray-500 text-sm leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </div>

      <footer className="border-t border-gray-100 py-8 px-6 text-center">
        <span className="text-xs text-gray-400">&copy; {new Date().getFullYear()} CombinedWork. All rights reserved.</span>
      </footer>
    </div>
  );
}
